import { createSelector } from 'reselect';
import { linkGridFulfillmentFilterToPdpExperienceSelector } from 'selectors/testTarget/offers/linkGridFulfillmentFilterToPdp/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showLinkGridFulfillmentFilterToPdpSelector = createSelector(
    isTestTargetReadySelector,
    linkGridFulfillmentFilterToPdpExperienceSelector,
    (testReady, show) => testReady && show
);

export { showLinkGridFulfillmentFilterToPdpSelector };
